import React, { useRef, useEffect, useState, useContext } from "react";

// Componentes PrimeReact
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { InputText } from "primereact/inputtext";

import AgGrid from "../../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../../../Base/Context/AuthContext/AuthContext";
import { ObtenerDetalleRequisa } from "../../../../../../../API/Suministros/IngresosMateriales/IngresosMaterialesRequest";

const ProductosOverlay = ({ Requisa, close, rowData, onChange }) => {
  const op = useRef(null);
  const buttom = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [requisasM, setRequisasM] = useState([]);

  const obtenerRequisasM = async () => {
    setLoading(true);
    const tempo = await ObtenerDetalleRequisa(Requisa);
    setRequisasM(tempo);
    setLoading(false);

  };

  const colums = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdRequisaDet",
      className: "Xsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Código",
      headerEn: "Code",
      field: "CodigoProducto",
      className: "small",
    },
    {
      header: "Producto",
      headerEn: "Product",
      field: "NombreProducto",
      className: "Xlarge",
      flex: 1,
      Sumary: "count",
    },
    {
      header: "Inventario",
      headerEn: "Inventory",
      field: "Quantity",
      Format: "Currency",
      className: "Xsmall",
    },
    {
      header: "Cant. Solicitada",
      field: "Qty",
      className: "Xsmall",
      Sumary: "count",      
      Format: "Currency",
      
    },
    {
      header: "Balance",
      headerEn: "Balance",
      field: "BalanceSalida",
      Format: "Currency",
      className: "Xsmall",
    },
  ];

  const table = {
    Columns: colums,
    Data: requisasM,
    loading: loading,
    onCellClicked: (e) => onChange(e, rowData),
  };

  useEffect(() => {
    obtenerRequisasM();
  }, []);

  return (
    <div style={{ maxWidth: "50vw" }}>
      <div className="p-inputgroup">
        <InputText
          value={rowData.NombreProducto}
          disabled
          placeholder="Producto"
          onClick={(e) => op.current.toggle(e)}
        />
        <Button
          ref={buttom}
          icon="pi pi-chevron-down"
          style={{ padding: "0.5rem 0.3rem" }}
          type="button"
          onClick={(e) => op.current.toggle(e)}
        />
      </div>

      <OverlayPanel
        ref={op}
        showCloseIcon
        dismissable={false}
        className="OverPanelProductos"
        onHide={close}
      >
        <div style={{ width: 1000, height: 300 }}>
          <AgGrid table={table} />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default ProductosOverlay;
